import React from 'react';
import experineceImg from '../../image/output-onlinegiftools.gif'

const Experience = () => {
    return (
        <div className='mt-5 pt-5 pb-0 pb-md-5 container'>
           
            <div className='row d-flex align-items-center'>
            <div className='col-md-6'>
                <img src={experineceImg} alt=""  className='img-fluid shadow-lg' data-aos="flip-left" />
            </div>
                <div className='col-md-6 mx-auto' data-aos="fade-left">
                 <h2 className='fw-bold font-monospace'>Experiences</h2>
                 <div className='border p-3 mt-3'>
                    <h4 className='mt-4 fw-bold'>Uttara InfoTech</h4>
                    <p>Postion: Intern Front End Developer</p>
                    <p>Duration: January 2020- April 2020 </p>
                    <ul>
                        <li>Collaborated with back-end developers and web designers to improve usability.</li>
                        <li>Got feedback from, and build solutions for, users and customers.</li>
                        <li> Delivered responsive, cross-browser compatible and accessibility compliant websites</li>
                        <li>Developed features to enhance the user experience.</li>
                    </ul>
                 </div>
                   
                </div>
            </div>
        </div>
    );
};

export default Experience;